<template>
  <portal to="modal">
    <div
      :class="[
        'modal-portal',
        { 'overlay-bg': show },
        { 'blue-bg': isCustomBg },
      ]"
    >
      <transition name="fade" appear>
        <slot></slot>
      </transition>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isCustomBg: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      handler(value) {
        document.body.classList.toggle('no-scroll', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'modal.scss';
</style>
